'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoadingButton from '@mui/lab/LoadingButton';
export default function Button({ children, icon: Icon, label, loading = false, ...props }) {
    const buttonProps = {
        loading,
        ...props
    };
    Icon &&
        Object.assign(buttonProps, {
            loadingPosition: 'start',
            startIcon: _jsx(Icon, {})
        });
    return (_jsxs(LoadingButton, { ...buttonProps, children: [label, children] }));
}
